import OperationAndTechnicalSupportIcon from './component'

export default OperationAndTechnicalSupportIcon
